<template>
  <question
    prevTitle="Back"
    nextTitle="Next"
    prevEnabled
    :nextEnabled="this.customers > 0"
    @prevClick="$router.go(-1)"
    @nextClick="next"
  >
    <div class="rounded shadow">
      <h3 class="pad inverted">Number of expected customers with a balance in 6 months time?</h3>
      <div class="input toplined">
        <input v-model.number.trim="customers" inputmode="numeric" pattern="[0-9]*" placeholder="0 customers"/>
      </div>
    </div>
  </question>
</template>
<style lang="scss" scoped>
.pad {
  padding: 1em;
}
.input {
  input {
    background-color: lightgrey;
    margin: 1em;
    border-radius: 7px;
  }
}
</style>
<script>
import question from "@/components/questionTemplate";

export default {
  props: {
    nextRoute: {
      type: String,
      default: "recap"
    }
  },
  components: {
    question
  },
  beforeMount: function() {
    this.customers = this.$store.state.formData.customers;
  },
  data: function() {
    return {
      customers: null
    };
  },
  methods: {
    next: function() {
      if (this.customers > 0) {
        this.$store.dispatch("setFormData", {
          customers: this.customers
        });
        this.$router.push(this.nextRoute);
      }
    }
  }
};
</script>